import React from 'react'
import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'
import { Link } from 'gatsby'

export const Element = styled((props) => <Link {...props} />)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $width }) => $width ? calculateResponsiveSize($width) : 'fit-content'};
  height: ${calculateResponsiveSize(24)};
  text-decoration: none !important;
  padding: 0 ${calculateResponsiveSize(20)};
  font-size: ${calculateResponsiveSize(10)};
  color: #FAF8F5;
  line-height: 1.1;
  letter-spacing: ${calculateResponsiveSize(1)};
  text-transform: uppercase;
  border: 1px solid #FAF8F5;
  background: transparent;
  transition: color 0.25s, background 0.25s;
  cursor: pointer;
  &:hover {
    color: #2E1619;
    background: #FAF8F5;
  }
  ${mediaMax('mobile')} {
    width: ${({ $widthMobile }) => $widthMobile ? calculateMobileResponsiveSize($widthMobile) : 'fit-content'};
    height: ${calculateMobileResponsiveSize(24)};
    padding: 0 ${calculateMobileResponsiveSize(20)};
    font-size: ${calculateMobileResponsiveSize(10)};
    letter-spacing: ${calculateMobileResponsiveSize(1)};
  }
`
